const loadZendesk = (id: string, callback?: () => void) => {
  const existingScript = document.getElementById("ze-snippet");
  if (!existingScript) {
    const script = document.createElement("script");
    script.src = `https://static.zdassets.com/ekr/snippet.js?key=${id}`;
    script.id = "ze-snippet";
    document.head.appendChild(script);
    script.onload = () => {
      if (callback) callback();
    };
  } else if (callback) {
    callback();
  }
};

const signIn = (jwt?: string) => {
  //@ts-ignore
  if (window.zE && jwt) {
    try {
      //@ts-ignore
      window.zE("webWidget", "updateSettings", {
        webWidget: {
          authenticate: {
            chat: {
              jwtFn: function (callback: (s: string) => void) {
                // Fetch your jwt token and then call our supplied callback below.
                callback(jwt);
              },
            },
          },
        },
      });
    } catch (err) {
      console.log("could not sign in to zendesk");
    }
  }
};

const zendesk = {
  loadZendesk,
  signIn,
};
export default zendesk;
